import { Pipe, PipeTransform } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { ChatMessageTextService } from './chat-message-text.service';

/**
 * Pure pipe that renders LLM-generated bot HTML through the design-system pipeline
 * (sanitize -> translate -> trust) provided by {@link ChatMessageTextService}.
 *
 * Being PURE, Angular memoizes the result per distinct `content` input and only
 * re-invokes `transform` when the reference changes. This replaces the previous
 * template method call `toSafeHtml(message.content)`, which re-ran DOMPurify plus
 * the DOM translator on every change-detection cycle for every message.
 *
 * Security and fallback behavior are unchanged: all of it lives in the service.
 */
@Pipe({
  name: 'safeBotHtml',
  standalone: false,
  pure: true
})
export class SafeBotHtmlPipe implements PipeTransform {
  constructor(private readonly messageText: ChatMessageTextService) {}

  transform(content: string | null | undefined): SafeHtml {
    return this.messageText.toSafeHtml(content || '');
  }
}
